import _ from "lodash";

import * as k4util from "@/utils/k4util";

import { $ref, $deref } from "./path";
import Node from "./node";

export default class ModelManager {
	static get modelName() {
		return "ModelManager";
	}

	constructor(k4model) {
		this.k4model = k4model.root();
		this.guids = {};
		this.paths = {};
	}

	async render() {
		// Setup guid -> path mappings
		this.guids = _.reduce(
			this.k4model.guids,
			(accum, node, guid) => {
				const path = node.path();
				accum[guid] = $ref(path);
				return accum;
			},
			{}
		);

		// Build directory of paths
		this.paths = this._buildPaths(this.k4model);

		// Dereference JSON pointers to create final model
		let model = null;
		try {
			model = await $deref({
				guids: this.guids,
				paths: this.paths,
			});
			model.paths = this._unmaskPaths(model.paths);
		} catch (e) {
			console.error("Error dereferencing model:", e);
		}

		return Object.freeze(model);
	}

	get scenes() {
		return _.filter(this.guids, ["cls", k4util.DEVICE_CLASS_SCENE]);
	}

	get triggers() {
		return _.filter(this.guids, ["cls", k4util.DEVICE_CLASS_TRIGGER]);
	}

	get actions() {
		return _.filter(this.guids, ["cls", k4util.DEVICE_CLASS_ACTION]);
	}

	_buildPaths(node, paths = {}) {
		const path = maskTrailingSpace(node.path());
		paths[path] = Node.create(node);

		for (let name in node.children()) {
			const child = node.child(name);
			paths = this._buildPaths(child, paths);
		}

		return paths;
	}

	_unmaskPaths(paths) {
		return _.mapKeys(paths, (node, path) => unmaskTrailingSpace(path));
	}
}

// CONTEXT K4ENT-337
// Auxiliary functions to make sure trailing spaces aren't trimmed on $deref
const maskTrailingSpace = path => path.replace(/ $/, " ~");
const unmaskTrailingSpace = path => path.replace(/ ~$/, " ");
